import { useQuery } from '@tanstack/react-query';
import { configService } from 'api/services/configService';
import { queryKeys } from 'shared/constants/queryKeys';

export function useAppConfig() {
  const { data } = useQuery({
    queryKey: queryKeys.config.features,
    queryFn: () => configService.getConfig().then((res) => res.data),
    staleTime: 5 * 60 * 1000,
  });

  return {
    smartReportEnabled: data?.features.smartReport ?? false,
  };
}
